const REACTIONS = {
    like: '👍',
} as const

export type ReactionString = keyof typeof REACTIONS

export const isValidReaction = (reaction: string): reaction is ReactionString => reaction in REACTIONS
export const getReactionEmoji = (reaction: ReactionString): string => REACTIONS[reaction]
